// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__31pC8","detailsBorder":"styles_detailsBorder__1RBZt"};